import React from 'react';
import {
    Canvas, Document, Page
} from '@react-pdf/renderer';

const DOTS_PER_MM = 8;
const POINTS_PER_MM = 72 / 25.4;
const POINTS_PER_DOT = POINTS_PER_MM / DOTS_PER_MM;
const THERMAL_BLACK = '#000000';
const THERMAL_TEXT_STROKE = 0.18;

const textPosition = (element) => {
    const xScale = element.xScale || 1;
    const textWidth = element.text.length * element.fontSize * 0.6 * xScale * POINTS_PER_DOT;
    let left = element.x * POINTS_PER_DOT;

    if (element.anchor === 'middle') {
        left -= textWidth / 2;
    } else if (element.anchor === 'end') {
        left -= textWidth;
    }

    return { left, xScale };
};

const paintText = (painter, element) => {
    const { left, xScale } = textPosition(element);
    painter
        .save()
        .translate(left, element.y * POINTS_PER_DOT)
        .scale(xScale, 1)
        .font('Courier-Bold')
        .fontSize(element.fontSize * POINTS_PER_DOT)
        .fillColor(THERMAL_BLACK)
        .strokeColor(THERMAL_BLACK)
        .fillOpacity(1)
        .strokeOpacity(1)
        .lineWidth(THERMAL_TEXT_STROKE)
        .lineJoin('round')
        .text(element.text, 0, 0, {
            lineBreak: false,
            fill: true,
            stroke: true
        })
        .restore();
};

const paintTicket = (page) => (painter) => {
    page.elements.forEach((element) => {
        if (element.type === 'text') {
            paintText(painter, element);
            return;
        }
        if (element.type === 'bar') {
            painter
                .rect(
                    element.x * POINTS_PER_DOT,
                    element.y * POINTS_PER_DOT,
                    element.width * POINTS_PER_DOT,
                    element.height * POINTS_PER_DOT
                )
                .fill(THERMAL_BLACK);
            return;
        }
        if (element.type === 'qr') {
            const moduleSize = element.moduleSize * POINTS_PER_DOT;
            painter
                .save()
                .translate(element.x * POINTS_PER_DOT, element.y * POINTS_PER_DOT)
                .scale(moduleSize)
                .path(element.path)
                .fill(THERMAL_BLACK)
                .restore();
        }
    });
};

const TicketPage = ({ page }) => {
    const width = page.widthMm * POINTS_PER_MM;
    const height = page.heightMm * POINTS_PER_MM;
    return (
        <Page
            wrap={false}
            size={{ width, height }}
            style={{ position: 'relative', backgroundColor: '#ffffff' }}
        >
            <Canvas style={{ width, height }} paint={paintTicket(page)} />
        </Page>
    );
};

const SystemTicketPdfDocument = ({ pages }) => (
    <Document title="" author="" subject="">
        {pages.map((page, index) => (
            <TicketPage key={`ticket-${index}`} page={page} />
        ))}
    </Document>
);

export default SystemTicketPdfDocument;
